import { createAction, handleActions } from 'redux-actions'
import api from '../api'
import * as subscriptionsActions from './subscriptions'

const GET_SUBSCRIPTION_DETAILS = createAction('subscriptions-admin/GET_SUBSCRIPTION_DETAILS')
const GET_SUBSCRIPTION_DETAILS_SUCCESS = createAction('subscriptions-admin/GET_SUBSCRIPTION_DETAILS_SUCCESS')

const SET_STATUS = createAction('subscriptions-admin/SET_STATUS')
const SET_STATUS_SUCCESS = createAction('subscriptions-admin/SET_STATUS_SUCCESS')
const SET_STATUS_ERROR = createAction('subscriptions-admin/SET_STATUS_ERROR')

const EDIT_SUBSCRIPTION = createAction('subscriptions-admin/EDIT_SUBSCRIPTION')
const EDIT_SUBSCRIPTION_SUCCESS = createAction('subscriptions-admin/EDIT_SUBSCRIPTION_SUCCESS')

const DELETE_SUBSCRIPTION = createAction('subscriptions-admin/DELETE_SUBSCRIPTION')
const DELETE_SUBSCRIPTION_SUCCESS = createAction('subscriptions-admin/DELETE_SUBSCRIPTION_SUCCESS')

const UNDO_SOFT_DELETE = createAction('subscriptions-admin/UNDO_SOFT_DELETE')
const UNDO_SOFT_DELETE_SUCCESS = createAction('subscriptions-admin/UNDO_SOFT_DELETE_SUCCESS')

const SET_ERROR = createAction('subscriptions-admin/SET_ERROR')

const SET_ACTIVE = createAction('subscriptions-admin/SET_ACTIVE')
const RESET_ACTIVE = createAction('subscriptions-admin/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('subscriptions-admin/UPDATE_ACTIVE')

const initialState = {
  active: null,
  detailedSubscription: null,
  loading: false,
  edit: false
}

export default handleActions(
  {
    [GET_SUBSCRIPTION_DETAILS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_SUBSCRIPTION_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      detailedSubscription: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [SET_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [EDIT_SUBSCRIPTION]: (state, action) => ({
      ...state,
      loading: true
    }),
    [EDIT_SUBSCRIPTION_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_SUBSCRIPTION]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_SUBSCRIPTION_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [UNDO_SOFT_DELETE]: (state, action) => ({
      ...state,
      loading: true
    }),
    [UNDO_SOFT_DELETE_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload.active },
      edit: action.payload.edit
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null,
      edit: false
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    }
  },
  initialState
)

export const getSubscriptionDetails = id => {
  return dispatch => {
    dispatch(GET_SUBSCRIPTION_DETAILS())
    return api
      .get('subscriptionsadmin/getSubscriptionDetails', id)
      .then(result => {
        dispatch(GET_SUBSCRIPTION_DETAILS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const changeStatus = (name, status) => {
  return (dispatch, getState) => {
    const id = getState().subscriptionsAdmin.subscription.detailedSubscription.id
    dispatch(SET_STATUS())
    return api
      .post('subscriptionsadmin/UpdateSubscriptionStatus', id, { name: name, status: status })
      .then(result => {
        dispatch(getSubscriptionDetails(id))
        dispatch(SET_STATUS_SUCCESS())
      })
      .catch(error => {
        dispatch(getSubscriptionDetails(id))
        dispatch(SET_STATUS_ERROR())
        // global message
      })
  }
}

export const editSubscription = subscription => {
  return dispatch => {
    dispatch(EDIT_SUBSCRIPTION())
    return api
      .post('subscriptionsadmin/updateSubscription', subscription.id, subscription)
      .then(result => {
        dispatch(resetActive())
        dispatch(EDIT_SUBSCRIPTION_SUCCESS(result))
        dispatch(getSubscriptionDetails(subscription.id))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const deleteItem = id => {
  return dispatch => {
    dispatch(DELETE_SUBSCRIPTION())
    return api
      .post('subscriptionsadmin/deleteSubscription', id, '')
      .then(result => {
        dispatch(resetActive())
        dispatch(DELETE_SUBSCRIPTION_SUCCESS(result))
        dispatch(subscriptionsActions.getSubscriptions())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const undoSoftDelete = id => {
  return dispatch => {
    dispatch(UNDO_SOFT_DELETE())
    return api
      .post('subscriptionsadmin/undoSoftDeleteSubscription', id, '')
      .then(result => {
        dispatch(resetActive())
        dispatch(UNDO_SOFT_DELETE_SUCCESS())
        dispatch(getSubscriptionDetails(id))
      })
      .catch(error => {
        dispatch(SET_ERROR())
      })
  }
}

export const setActive = (active, edit) => {
  return dispatch => {
    dispatch(SET_ACTIVE({ active, edit }))
  }
}

export const resetActive = () => {
  return dispatch => {
    dispatch(RESET_ACTIVE())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriptions-admin/subscription.js